import { useEffect, useState } from "react";

import LBM from "..";

import { useTipoApontamento } from "entity/Indicador/components/apontamento/fields/ApontamentoAmostraParams";
import ApontamentoObservacao from "entity/Indicador/components/apontamento/fields/ApontamentoObservacao";
import ApontamentoResultado from "entity/Indicador/components/apontamento/fields/ApontamentoResultado";
import ApontamentoColetas from "entity/Indicador/components/apontamento/fields/ApontamentoColetas";
import ApontamentoImages from "entity/Indicador/components/apontamento/fields/ApontamentoImages";
import ApontamentoClienteParams, {
    ApontamentoParamItem,
} from "entity/Indicador/components/apontamento/fields/ApontamentoClienteParams";

import { useFieldPrefix, useFieldValue } from "components/form/input/NestedField";
import TextInput from "components/form/input/TextInput";
import FormRow from "components/form/FormRow";
import { Field, useForm } from "react-final-form";
import BasicAccordion from "components/basic/BasicAccordion";
import FormContent from "components/form/FormContent";
import DateInput from "components/form/input/DateInput";
import { Autocomplete, TextField } from "@mui/material";
import EntitySearchInput from "components/form/EntitySearch/EntitySearchInput";
import Variedade from "entity/Variedade";

export default function LBMEditFields({ visita, TipoClass }) {
    const [tipo] = useTipoApontamento();
    const params = visita.cliente.getParams(LBM, tipo, TipoClass);

    const [apontamento] = useFieldValue();
    const form = useForm();

    const [talhoes, setTalhoes] = useState([]);
    const talhaoFieldName = useFieldPrefix("talhao");

    useEffect(() => {
        if (apontamento) {
            apontamento.conformidade = LBM.calcConformidade(apontamento, params);
            form.change("conformidade", LBM.calcConformidade(apontamento, params));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apontamento, params]);

    useEffect(() => {
        if (visita.fazenda && visita.fazenda.data.talhoesFazenda) {
            setTalhoes(["", ...visita.fazenda.data.talhoesFazenda]);
        }
    }, [visita.fazenda]);

    return (
        <>
            <BasicAccordion title="Dados Básicos" defaultExpanded={true} fullWidth disableGutters>
                <FormContent>
                    <FormRow>
                        <DateInput showTime name="date" label="Data / Hora Coleta" disabled />
                    </FormRow>
                    <FormRow>
                        <Field
                            name={talhaoFieldName}
                            validate={(value) => (value && value.length > 0 ? undefined : "Campo obrigatório")}
                            render={({ input, meta }) => (
                                <div style={{ flex: 1 }}>
                                    <Autocomplete
                                        // multiple={input.value?.length ? true : false}
                                        multiple={!input.value || input.value.length ? true : false}
                                        value={input.value || []}
                                        onChange={(_, value) => input.onChange(value)}
                                        options={talhoes}
                                        getOptionLabel={(option) => option.nome || ""}
                                        isOptionEqualToValue={(option, value) => option.nome === value.nome}
                                        sx={{ flex: 1 }}
                                        renderInput={(params) => (
                                            <TextField
                                                label="Talhão"
                                                variant="standard"
                                                {...params}
                                                error={meta.error && meta.touched}
                                                helperText={meta.touched ? meta.error : ""}
                                            />
                                        )}
                                        renderOption={(props, option) => <li {...props}>{option.nome}</li>}
                                    />
                                </div>
                            )}
                        />
                    </FormRow>
                    <FormRow>
                        <EntitySearchInput name="variedade" label="Variedade" EntityClass={Variedade} />
                    </FormRow>
                </FormContent>
            </BasicAccordion>

            <ApontamentoClienteParams params={params}>
                {params ? (
                    <>
                        <ApontamentoParamItem label="Meta (% Brocas):">{params.meta}</ApontamentoParamItem>
                        <ApontamentoParamItem label="Max. Brocas Internas:">
                            {params.metaBrocasInternas}
                        </ApontamentoParamItem>
                    </>
                ) : null}
            </ApontamentoClienteParams>

            <ApontamentoColetas visita={visita}>
                <TextInput type="number" name="numBrocas" label="Nº de Brocas Encontradas" />
                <TextInput type="number" name="numCanas" label="Nº de Canas Avaliadas" />
                <TextInput type="number" name="brocasInternas" label="Nº de Brocas Internas" />
            </ApontamentoColetas>
            <ApontamentoResultado conformidadeLabel="% Brocas">
                <FormRow>
                    <TextInput name="totalBrocas" label="Total de Brocas Encontradas" disabled />
                </FormRow>
                <FormRow>
                    <TextInput name="totalCanas" label="Total de Canas Avaliadas" disabled />
                </FormRow>
                <FormRow>
                    <TextInput name="totalBrocasInternas" label="Total de Brocas Internas" disabled />
                </FormRow>
                <FormRow>
                    <TextInput name="percentBrocasInternas" label="Porcentagem de Brocas Internas" disabled />
                </FormRow>
            </ApontamentoResultado>

            <ApontamentoObservacao />
            <ApontamentoImages visita={visita} />
        </>
    );
}
